<template>
  <v-card class="pa-4" outlined rounded="lg">
    <h6>Autenticação 3DS</h6>
    <template v-if="!active">
      <v-alert type="warning" text dense>
        A autenticação 3DS não está ativa para este evento.
      </v-alert>

      <v-form v-model="valid" @submit.stop>
        <v-text-field
          v-model="min3DSAmount"
          label="Valor mínimo para 3DS"
          type="number"
          dense
          outlined
          :disabled="!!loading"
          :rules="[
            (v) => !!v || 'Valor mínimo para 3DS é obrigatório',
            (v) => v > 0 || 'Valor mínimo para 3DS deve ser maior que 0',
          ]"
        />

        <v-alert v-if="error" type="error" text dense>
          {{ error }}
        </v-alert>

        <div class="d-flex justify-space-between flex-wrap">
          <v-btn
            :disabled="!!loading"
            :loading="loading === 'all'"
            small
            color="info"
            depressed
            @click="runActivate(0)"
          >
            Ativar todos as compras
          </v-btn>
          <v-btn
            :disabled="!valid || !!loading"
            :loading="loading === 'min'"
            small
            color="success"
            depressed
            @click="runActivate(false)"
          >
            Ativar a partir de
            {{ Math.max(min3DSAmount || 0, 0) }}
          </v-btn>
        </div>
      </v-form>
    </template>
    <template v-else>
      <v-alert type="success" text dense>
        A autenticação 3DS é obrigatoria para
        <template v-if="min3DSAmount === 0"> todas as compras </template>
        <template v-else>
          compras a partir de {{ min3DSAmount | currency(true) }}
        </template>
      </v-alert>

      <v-alert v-if="error" type="error" text dense>
        {{ error }}
      </v-alert>

      <div class="d-flex justify-space-between">
        <v-btn
          :disabled="loading"
          :loading="!!loading"
          text
          small
          color="error"
          @click="runDeactivate"
        >
          Desativar
        </v-btn>
      </div>
    </template>
  </v-card>
</template>

<script>
import PARTY from "@/services/admin/parties";

export default {
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: false,
    active: false,
    loading: false,
    error: false,

    min3DSAmount: 0,
  }),
  methods: {
    async runActivate(min3DSAmount = false) {
      try {
        this.loading = !min3DSAmount ? "min" : "all";
        this.error = null;

        min3DSAmount =
          min3DSAmount === false ? this.min3DSAmount : min3DSAmount;

        await PARTY.update(this.party.id, {
          min3DSAmount: parseInt(min3DSAmount),
        });

        this.min3DSAmount = min3DSAmount;
        this.active = min3DSAmount !== -1;
      } catch (error) {
        this.error = error.message || error;
      } finally {
        this.loading = false;
      }
    },
    async runDeactivate() {
      try {
        this.loading = true;
        this.error = null;

        await PARTY.update(this.party.id, {
          min3DSAmount: -1,
        });

        this.active = false;
      } catch (error) {
        this.error = error.message || error;
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.active = this.party.min3DSAmount !== -1;
    this.min3DSAmount = Math.max(this.party.min3DSAmount, 0);
  },
};
</script>

<style></style>
